import { lazy } from 'app/lazy'

export const Main = lazy(() => import('./Main'))
